import { selectVideoToWatch, showPopUp } from 'pages/Course/store'
import { connect } from 'react-redux'
import UI from './UI'
import { openQuiz } from 'pages/Course/Quizz/store'

const mapStateToProps = ({ course, referential, user, identity, quiz }) => ({
  ProfileType: referential?.ProfileTypes ? referential?.ProfileTypes[user?.ProfileType] : null,
  courseId: course.Course.Id
})

const mapDispatchToProps = dispatch => ({
  selectVideoToWatch: video => dispatch(selectVideoToWatch(video)),
  showPopUpAction: state => dispatch(showPopUp(state)),
  openQuiz: isOpen => dispatch(openQuiz(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
